import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { AvatarModule } from '../../../common/avatar/avatar.module';
import { ButtonModule } from '../../../common/button/button.module';
import { BadgeModule } from './../../../common/badge/badge.module';
import { CardModule } from './../../../common/card/card.module';
import { DateModule } from './../../../common/date/date.module';
import { DividerModule } from './../../../common/divider/divider.module';
import { DropdownModule } from './../../../common/dropdown/dropdown.module';
import { HeadingModule } from './../../../common/heading/heading.module';
import { IconModule } from './../../../common/icon/icon.module';
import { PipesModule } from './../../../common/pipes/pipes.module';
import { TooltipModule } from './../../../common/tooltip/tooltip.module';
import { TruncateModule } from './../../../common/truncate/truncate.module';
import { RtUICoreOverlayModule } from './../../../core/core.module';
import { RtUIDialogsModule } from './../../../dialogs/dialogs.module';
import { AttachmentItemComponent } from './attachment-item.component';

@NgModule({
  declarations: [AttachmentItemComponent],
  exports: [AttachmentItemComponent],
  imports: [
    CardModule,
    CommonModule,
    IconModule,
    I18nModule,

    TooltipModule,
    RtUICoreOverlayModule,
    DropdownModule,
    TruncateModule,
    AvatarModule,
    HeadingModule,
    DateModule,
    DividerModule,
    RtUIDialogsModule,
    PipesModule,
    BadgeModule,
    ButtonModule,
  ],
})
export class AttachmentItemModule {}

export { AttachmentItemComponent, AttachmentItemTranslations } from './attachment-item.component';
